import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { FormikProps } from 'formik';
import { DividerSection } from '../../../../global/components/layout/divider-section';
import { FormGroup } from '../../../../global/components/layout/form-group';
import { FormField } from '../../../../global/components/form-element/form-field';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { PerformPersonSearchContext, PersonSearchContext } from '../../../arc/features/person-search/person-search-model';
import { handleOSCRRBlur } from '../../../arc/features/person-search/oscrr-helpers';
import { FieldAutomationIds } from '../../../../global/constants/field-automation-ids';

interface EmailProps {
	labelSetting: LabelSettingProps;
	formProps: FormikProps<any>;
	officeEmailRequired?: boolean;
	removeDivider?: boolean;
	hideDescription?: boolean;
	hideBusiness?: boolean;
	officerSearch?: boolean;
	personalEmailRequired?: boolean;
}

export function EmailInfo(props: EmailProps) {
	const { labelSetting, formProps, removeDivider, officeEmailRequired, hideDescription, hideBusiness, officerSearch, personalEmailRequired } = props;

	const personSearchKey = useContext(PersonSearchContext);
	const performPersonSearch = useContext(PerformPersonSearchContext);
	const dispatch = useDispatch();

	const handleBlur = (e, fieldName: string) => {
		const { value } = e.target;

		formProps.setFieldTouched(fieldName, true);

		if (performPersonSearch) {
			handleOSCRRBlur(dispatch, formProps, personSearchKey, fieldName, value, officerSearch);
		}
	};

	return (
		<DividerSection
			removeDivider={removeDivider}
			showCleryIcon
			sectionText={labelSetting.emailSectionTitle}
			sectionDescription={(!hideDescription || officeEmailRequired || hideBusiness) ? '' : labelSetting.emailSectionDescription}>
			<FormGroup>
				{
					!hideBusiness &&
					<FormField
						name='office_email_address'
						component='input'
						label={props.labelSetting.businessEmailLabel}
						touched={formProps.touched}
						errors={formProps.errors}
						onBlur={(e) => handleBlur(e, 'office_email_address')}
						required={officeEmailRequired}
						testId={FieldAutomationIds.businessEmail}
					/>
				}
				<FormField
					name='personal_email_address'
					component='input'
					label={props.labelSetting.personalEmailLabel}
					errors={formProps.errors}
					touched={formProps.touched}
					onBlur={(e) => handleBlur(e, 'personal_email_address')}
					required={personalEmailRequired}
					testId={FieldAutomationIds.personalEmail}
				/>
			</FormGroup>
		</DividerSection >
	);
}

EmailInfo.defaultProps = {
	removeDivider: false,
	officeEmailRequired: false,
	hideDescription: false,
	hideBusiness: false,
	officerSearch: false,
	personalEmailRequired: false,
};